import ADConfirmation from './ADConfirmation';

export default ADConfirmation;
